
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
// import { AppConstant } from './../../shared/constant/app.constant';
 
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../../shared/services/app.config.service';
import { AuthHttp } from '../../../admin/services';

let AppConstant: any = {};
@Injectable()
export class ContingentLoanService {
 
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }


    getApprovalsContingentLoan() {
        return this.http.get(`contingent/approvals/loanusage`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    // saveContingentLoan(data) {
    //     return this.http.post(`contingent/loanusage`,data)
    //     .map((res: any) => res)
    //     .catch((error: any) => Observable
    //         .throw(error.error || 'Server error'));
    // }

    // saveContingentLoan(file: File, body: any) {
    //     let bodyObj = JSON.stringify(body);


    //     return new Promise((resolve, reject) => {

    //         let url = `contingent/loanusage`;
    //         // let url = `media/upload-file`;
    //         let xhr: XMLHttpRequest = new XMLHttpRequest();

    //         xhr.onreadystatechange = () => {
    //             if (xhr.readyState === 4) {
    //                 if (xhr.status === 200) {
    //                     resolve(JSON.parse(xhr.response));
    //                 } else {
    //                     reject(xhr.response);
    //                 }
    //             }
    //         };

    //         xhr.open('POST', url, true);
    //         let formData = new FormData();

    //         formData.append("file", file, file.name);

    //         for (var key in body) {
    //             formData.append(key, body[key]);
    //         }

    //         let token = this.http.getAuthorizationHeader();
    //         xhr.setRequestHeader('Authorization', `Bearer ${token}`);



    //         xhr.send(formData);
    //     });
    // }

    saveContingentLoan(data) {
        return this.http.post(`contingent/loanusage`,data).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getContingentLoan() {
        return this.http.get(`contingent/getcontingentloan`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getApproveContingentLoanUsage(body) {
        return this.http.post(`contingent/loanusage-approval`, JSON.stringify(body)).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getContingentUsage(loanId) {
        return this.http.get(`contingent/get-contingent-usage/${loanId}`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    //loanusage-approval
}